import { render, staticRenderFns } from "./project-offer.vue?vue&type=template&id=3a4b1456&scoped=true"
import script from "./project-offer.vue?vue&type=script&lang=js"
export * from "./project-offer.vue?vue&type=script&lang=js"
import style0 from "./project-offer.vue?vue&type=style&index=0&id=3a4b1456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b1456",
  null
  
)

export default component.exports